/*=================================================
    정규식 통과여부를 반환 
=================================================*/
import type { RegExType } from '@/types/RegExType';

import getRegExp from './getRegExp';

/**
 *
 * @param type - 체크하려는 정규식 종류
 * @param str - 입력 문자열
 * @returns 정규식 통과 여부를 반환
 */
export default function validateRegExp(type: RegExType, str: string) {
  const regExp = getRegExp(type);

  return regExp?.test(str);
}
